const Analytics = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M3 9.5C3 12.9216 5.64378 15.7257 9.00001 15.9811V16.9836C5.09099 16.7263 2 13.4741 2 9.5C2 5.35786 5.35787 2 9.50001 2C13.4742 2 16.7264 5.09102 16.9836 9.00007C16.2502 9.00595 15.6108 9.40661 15.2676 10H10.5C9.67159 10 9.00001 9.32843 9.00001 8.5V3.01894C5.64378 3.27426 3 6.07838 3 9.5ZM15.9811 9C15.7383 5.8088 13.1912 3.2617 10 3.01894V8.5C10 8.77614 10.2239 9 10.5 9H15.9811ZM16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11V18C18 18.5523 17.5523 19 17 19C16.4477 19 16 18.5523 16 18V11ZM10 15C10 14.4477 10.4477 14 11 14C11.5523 14 12 14.4477 12 15V18C12 18.5523 11.5523 19 11 19C10.4477 19 10 18.5523 10 18V15ZM13 13C13 12.4477 13.4477 12 14 12C14.5523 12 15 12.4477 15 13V18C15 18.5523 14.5523 19 14 19C13.4477 19 13 18.5523 13 18V13Z"
      fill="currentColor"
    />
  </svg>
);

export default Analytics;
